import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, timer, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment'

@Injectable({
  providedIn: 'root'
})
export class Retry401Interceptor implements HttpInterceptor {

  private readonly maxRetries = 3;
  private readonly initialRetryDelay = 1000; // this value increase exponentially between each retry

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.makeRequestWithRetry(req, next, 0);
  }

  private makeRequestWithRetry(
    req: HttpRequest<any>,
    next: HttpHandler,
    retryCount: number
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (
          error.status === 401 &&
          retryCount < this.maxRetries &&
          req.url.includes(environment.apiHost) &&
          req.method === 'GET'
        ) {
          const delay = this.initialRetryDelay * Math.pow(2, retryCount);

          return timer(delay).pipe(
            switchMap(() => this.makeRequestWithRetry(req, next, retryCount + 1))
          );
        }
        
        return throwError(() => error);
      })
    );
  }
}
